import React from "react"
import clsx from "clsx"
//import I18n from "i18n-js/index.js.erb"
import RoomBuilderErrors from "../RoomBuilderErrors"
import MultiSelect from "../../Selects/MultiSelect"

class RoomBuilderConnectedRooms extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'connected_rooms',
      'tab-pane': true
    })
    return (
      <div className={`${tabClasses} root`} id="connected_rooms">
        <div className="rooms single">
          { this.renderErrors() }
          <div className="row">

              { this.renderConnectedRoomsForm() }

          </div>
        </div>
      </div>
    )
  }

  renderConnectedRoomsForm() {
    var inputs = this.props.all_rooms.map(room => {
      return {
        label_primary: room.identifier,
        label_secondary: room.connected_rooms,
        id: room.id
      }
    })
    return (
      inputs.length
      ?
      <div className="col">
        <MultiSelect
          header_primary="room_identifier"
          header_secondary="connected_room_identifier"
          inputs={inputs}
          selected_inputs={this.props.connected_room_ids || []}
          onChange={this.props.onConnectedRoomsChange} />
      </div>
        :
        <div className="no-records">
          <span className="none">{I18n.t('none')}</span>
        </div>
    )
  }

  renderErrors() {
    if(this.props.errors){
      var errors = RoomBuilderErrors.general(this.props.errors)
      if (errors && errors.length) {
        var idx = 0
        var errors = errors.map((error) => {
          idx = idx + 1
          return <li key={error + idx}>{error}</li>
        })
        return (
          <div className="alert alert-danger">
            <ul>{errors}</ul>
          </div>
        )
      }
    } 
  }

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0
      
      var errors = this.props.errors[field].map( (error) => {
        if(field === 'identifier') field = I18n.t('room_identifier')
        idx = idx + 1
        return <li key={idx}><b>{field}</b> {error}</li>
      })
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  renderFieldClasses(field) {
    var classname = 'form-control'
    if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors[field]) {
      classname = classname + ' has-errors'
    }
    return classname
  }
}

export default RoomBuilderConnectedRooms